"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_play__store(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "7146fe7d-7c5f-4e30-866e-300f928324b4",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "play-circle"), /*#__PURE__*/React.createElement("g", {
    id: "11f82bc8-0750-41d1-96f4-14f7dce5cf25",
    "data-name": "Play_circle_ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68,55.71v80.23A7,7,0,0,0,74.6,143,6.83,6.83,0,0,0,79,141.58l1-.71,51.53-38.16,1.52-1.13a6.67,6.67,0,0,0,0-11.19l-1.46-1.1-51.38-38c-2.14-1.75-4.8-3-7.89-1.67A7.29,7.29,0,0,0,68,56.29v.54",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _default = ic_play__store;
exports.default = _default;